module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAASElEQVQ4y2P4jwQ+MAww7wADDNgPAh7zfyATSAwGHgMoqP4wDAYe/x8g7wPMZQPMA6ccuMsGlAeOLCB/MPAGVbgMnjw9eMo6ALP+/ON3xB7AAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTE2VDE3OjE4OjExKzA5OjAwO1z6VwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00007_100x100.png
// module id = QLQ5
// module chunks = 0